import { createStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
//#region src/async-tasks-store/async-tasks-store.ts
var r = (e) => Math.min(1, Math.max(0, e)), i = e((e) => ({
	tasks: {},
	registerTask: (t) => e((e) => {
		let n = Date.now(), i = e.tasks[t.id];
		return { tasks: {
			...e.tasks,
			[t.id]: {
				...i,
				id: t.id,
				kind: t.kind,
				label: t.label ?? i?.label,
				description: t.description ?? i?.description,
				spaceId: t.spaceId ?? i?.spaceId,
				status: "InProgress",
				progress: r(t.progress ?? 0),
				error: null,
				startedAt: i?.startedAt ?? n,
				updatedAt: n
			}
		} };
	}),
	updateTask: (t, n) => e((e) => {
		let i = e.tasks[t];
		return i ? { tasks: {
			...e.tasks,
			[t]: {
				...i,
				...n,
				progress: n.progress === void 0 ? i.progress : r(n.progress),
				updatedAt: Date.now()
			}
		} } : e;
	}),
	setProgress: (t, n) => e((e) => {
		let i = e.tasks[t];
		return i ? { tasks: {
			...e.tasks,
			[t]: {
				...i,
				progress: r(n),
				updatedAt: Date.now()
			}
		} } : e;
	}),
	settleTask: (t, n, r) => e((e) => {
		let i = e.tasks[t];
		return i ? { tasks: {
			...e.tasks,
			[t]: {
				...i,
				status: n,
				progress: n === "Completed" ? 1 : i.progress,
				error: r ?? null,
				updatedAt: Date.now()
			}
		} } : e;
	}),
	removeTask: (t) => e((e) => {
		if (!e.tasks[t]) return e;
		let n = { ...e.tasks };
		return delete n[t], { tasks: n };
	}),
	clearSettled: () => e((e) => {
		let t = {};
		for (let n of Object.values(e.tasks)) n.status === "InProgress" && (t[n.id] = n);
		return { tasks: t };
	})
})), a = (e) => t(i, n(e));
//#endregion
export { i as asyncTasksStore, a as useAsyncTasksStore };
